import { ReactSVG } from "react-svg";

import { OfficeAddressRow } from "services/api/offices/types";
import { Badge } from "ui/components/Badge";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

export const OFFICE_ADDRESS_COLUMNS = (
  handleDeleteClick: (event: React.MouseEvent<HTMLDivElement>, id: string) => void
): Column[] => [
  {
    title: "Adresa",
    field: "line1",
    type: ColumnTypes.custom,
    render: (row: OfficeAddressRow) => (
      <div>
        <div className="text-md font-medium text-slate-600">{row.line1}</div>

        {row.line2 && <div className="text-xs text-slate-500 mt-0.5">{row.line2}</div>}
      </div>
    ),
  },
  {
    title: "Mjesto",
    field: "city",
    type: ColumnTypes.custom,
    render: (row: OfficeAddressRow) => (
      <div className="text-sm text-slate-900">
        <div>{[row.postalCode, row.city].filter(Boolean).join(" ")}</div>

        {(row.state || row.country) && (
          <div className="text-xs text-slate-500">
            {[row.state, row.country].filter(Boolean).join(", ")}
          </div>
        )}
      </div>
    ),
  },
  {
    title: "Opis",
    field: "description",
    type: ColumnTypes.custom,
    render: (row: OfficeAddressRow) => (
      <span className="text-sm text-slate-500">{row.description}</span>
    ),
  },
  {
    title: "",
    field: "primary",
    type: ColumnTypes.custom,
    render: (row: OfficeAddressRow) =>
      row.primary ? <Badge text="Primarna" variant="info" height="small" /> : <></>,
  },
  {
    title: "",
    field: "",
    type: ColumnTypes.custom,
    render: (row: OfficeAddressRow) => (
      <div
        onClick={(e) => handleDeleteClick(e, row.id)}
        className="flex justify-end items-center h-[30px] cursor-pointer"
      >
        <ReactSVG src="/media/icons/trash.svg" className="w-4 h-4 stroke-[#bd0000]" />
      </div>
    ),
  },
];
